import componentSlider from "../../common/componentSlider.js";

const CONTAINER_FULL_BREAKPOINT = 681;
const CONTAINER_70_BREAKPOINT = 781;

/**
 * Get breakpoint depending on the container type.
 * Breakpoint determines when component shifts from carousel to grid layout
 * @param {HTMLElement} el
 * @returns {number | null} - Breakpoint in pixels or null if there's no breakpoint
 */
function getBreakpoint(el) {
  const container = el.closest(".container");

  if (!container) return CONTAINER_FULL_BREAKPOINT;

  if (container.classList.contains("container--100"))
    return CONTAINER_FULL_BREAKPOINT;
  else if (container.classList.contains("container--70"))
    return CONTAINER_70_BREAKPOINT;
  else if (container.classList.contains("container--50-50")) return null;
  else return CONTAINER_FULL_BREAKPOINT;
}

export default () => {
  document
    .querySelectorAll(".js-image-promo-grid")
    .forEach((el, parentIndex) => {
      if (document.querySelector(".is-page-editor")) return;

      const config = {
        slidesToShow: 1,
        slidesToScroll: 1,
      };

      const numberChildren = el.querySelectorAll(
        ".js-slide-container > *",
      ).length;

      const listEl = el.querySelector(".image-promo-grid__list");

      if (numberChildren < 4) {
        listEl.classList.add("image-promo-grid__list--fewer-than-four");
      } else if (numberChildren === 5) {
        listEl.classList.add("image-promo-grid__list--five-items");
      } else if (numberChildren === 6) {
        listEl.classList.add("image-promo-grid__list--six-items");
      }

      if (numberChildren < 2) {
        el.classList.add("image-promo-grid--no-slider");
        return;
      }

      const breakpoint = getBreakpoint(el);

      config.mobileFirst = true;
      if (breakpoint) {
        config.responsive = [
          {
            breakpoint: breakpoint,
            settings: "unslick",
          },
        ];
      }

      if (document.dir === "rtl" || el.closest('[dir="rtl"]')) {
        config.rtl = true;
        el.dataset.isRtl = "true";
      }

      let activeSlider = window.innerWidth < breakpoint;

      const sliderControls = componentSlider(el, config);

      if (breakpoint) {
        window.addEventListener("resize", () => {
          if (!activeSlider && window.innerWidth < breakpoint) {
            activeSlider = true;
            sliderControls.createSlider();
          }

          if (activeSlider && window.innerWidth >= breakpoint) {
            activeSlider = false;
          }
        });
      }
    });
};
